( function( $ ){

    const scroll_zoom = () => {
        let scrollBottom   = $(window).scrollTop() + $(window).height();
        $( '.scroll_and_zoom' ).each( function(){
            let this_top    = $( this ).offset().top;
            let this_height = $( this ).height();
            if( this_top < scrollBottom + 200 && this_top + this_height > scrollBottom - 200 ){
                
                // Zoom image
                let from_top = scrollBottom - this_top;
                let zoom_percent = 1 + (from_top / this_height);
                $( this ).find( 'img' ).css({ transform: 'scale(' + zoom_percent + ')' });
                
                // Switch Content Block
                let $blocks         = $( this ).find( '.content-block' );
                let step_pixels     = this_height / $blocks.length; //1 / $blocks.length;
                
                let x = 1;
                while( from_top > step_pixels * x ){
                    x++;
                }
                
                let $active_block = $blocks.eq(  x >= 2 ? x - 2 : 0 );
                if( $active_block.length ){
                    $( '.content-block.active' ).removeClass( 'active' );
                    $active_block.addClass( 'active' );
                }

            }
        });
    }

    $( window ).on( 'scroll', scroll_zoom );
    scroll_zoom();

})( jQuery );